import type { ScopeNoteTag } from '../../../types/case-container'

export const TAG_COLOURS: Record<ScopeNoteTag, string> = {
  hypothesis: 'bg-purple-100 text-purple-700 dark:bg-purple-950/50 dark:text-purple-400',
  question: 'bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400',
  finding: 'bg-green-100 text-green-700 dark:bg-green-950/50 dark:text-green-400',
  action: 'bg-blue-100 text-blue-700 dark:bg-blue-950/50 dark:text-blue-400',
  important: 'bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-400',
}
